module.exports = __webpack_public_path__ + "img/15.6b081767.png";